
export const getTestTypeByActiveRadio = (activeRadio: string) => {
    if(activeRadio === 'Upload Milestone Test') return 'phase';
    if(activeRadio === 'Upload Main Test') return 'main'; 
}